<template>
  <div class="high-search">
    <div
      v-for="(item, index) in searchList"
      :key="item.id"
      class="search-group">
      <flex
        v-for="(search, i) in item.searchItems"
        :key="i"
        justify="center"
        align="center"
        class="search-item">
        <div class="rule-wrapper">
          <el-select
            v-if="i > 0"
            slot="append"
            v-model="search.rule"
            size="small"
            placeholder="">
            <el-option
              v-for="item in ruleOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"/>
          </el-select>
          <flex
            v-else
            align="center"
            justify="between"
            @click="deleteGroup(item.id, index)">
            <span>第{{ index + 1 }}组</span>
            <i
              v-if="index > 0"
              class="el-icon-delete"/>
          </flex>
        </div>
        <flex class="search-option">
          <div class="type-select">
            <el-select
              v-model="search.type"
              style="width: 200px;"
              size="small"
              placeholder="请选择">
              <el-option
                v-for="item in typeOptions"
                :key="item"
                :label="item"
                :value="item"/>
            </el-select>
          </div>
          <!-- <el-select
            v-if="isSelectType(search.type) && isSelectType(search.type).field === 'listCompname'"
            v-model="search.word"
            size="small"
            style="flex: 1;"
            filterable
            placeholder="请选择">
            <el-option
              v-for="item in selectListByType(search.type)"
              :key="item"
              :label="item"
              :value="item"/>
          </el-select> -->
          <el-cascader
            v-if="isSelectType(search.type)"
            v-model="search.word"
            :options="selectListByType(search.type)"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              emitPath: false,
              label: 'name',
              value: 'name'
            }"
            filterable
            style="flex: 1;"
            size="small"
            clearable/>
          <el-input
            v-else
            v-model="search.word"
            placeholder="请输入内容"
            size="small"
            style="flex: 1;"
            class="input-with-select"/>
        </flex>
        <flex
          align="center"
          class="button-wrapper">
          <i
            v-if="i > 0"
            style="margin-right: 10px;"
            class="el-icon-minus"
            @click="deleteSearchItem(item.searchItems, i)"/>
          <i
            v-if="i === item.searchItems.length - 1"
            class="el-icon-plus"
            @click="addSearchItem(item.searchItems)"/>
        </flex>
      </flex>
      <el-select
        v-if="searchList.length > 1 && index !== searchList.length - 1"
        slot="append"
        v-model="item.rule"
        size="small"
        placeholder="">
        <el-option
          v-for="item in ruleOptions"
          :key="item.value"
          :label="item.name"
          :value="item.value"/>
      </el-select>
    </div>
    <div
      class="add-group"
      @click="addGroup">
      添加分组
    </div>
    <flex class="time-options">
      <div class="options-item">
        <span class="title">发布时间</span>
        <el-date-picker
          v-model="postTime"
          :default-time="['00:00:00', '23:59:59']"
          value-format="timestamp"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"/>
      </div>
      <div class="options-item">
        <span class="title">更新时间</span>
        <el-select
          slot="append"
          v-model="updateTime"
          size="small"
          clearable
          placeholder="">
          <el-option
            v-for="item in timeOptions"
            :key="item"
            :label="item"
            :value="item"/>
        </el-select>
      </div>
    </flex>
    <div class="bottom-button">
      <span
        class="clear-text"
        @click="clearSearch">
        重置条件
      </span>
      <button
        class="submit-button"
        @click="submitSearch">
        检索
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      ruleOptions: [{
        name: 'AND',
        value: '&'
      }, {
        name: 'OR',
        value: '|'
      }, {
        name: 'NOT',
        value: '!'
      }],
      typeOptions: ['分类', '国家标签', '省标签', '标签', '关键词', '摘要', '作者', '发布机构', '发布来源'],
      // accuracyOptions: ['精确', '模糊'],
      searchList: [
        {
          id: 'aaa',
          searchItems: [
            {
              word: '',
              type: '分类'
              // accuracy: '精确'
            }
          ],
          rule: '&'
        }
      ],
      postTime: null,
      updateTime: '',
      timeOptions: ['最近三天', '最近一周', '最近一月', '最近三月', '最近一年'],
      selectTypes: [
        {
          type: '分类',
          field: 'listCatalogName'
        },
        {
          type: '标签',
          field: 'listTagName'
        },
        {
          type: '发布机构',
          field: 'listCompname'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['highSearch', 'listCatalogName', 'listTagName', 'listCompname']),
    isSelectType () {
      return type => {
        return this.selectTypes.find(v => v.type === type)
      }
    },
    selectListByType () {
      return type => {
        let item = this.selectTypes.find(v => v.type === type)
        return this[item.field]
      }
    }
  },
  methods: {
    // 初始化数据
    setData () {
      if (this.highSearch) {
        this.searchList = this.highSearch.searchList
        this.postTime = this.highSearch.postTime || null
        this.updateTime = this.highSearch.updateTime || ''
      }
    },
    // 添加分组
    addGroup () {
      this.searchList.push({
        id: this.$options.filters.GUID(),
        searchItems: [
          {
            word: '',
            rule: '&',
            type: '分类'
          }
        ],
        rule: '&'
      })
    },
    // 删除分组
    deleteGroup (id, index) {
      this.searchList.splice(index, 1)
    },
    // 添加一条新的筛选条件
    addSearchItem (searchItems) {
      searchItems.push({
        word: '',
        rule: '&',
        type: '分类'
      })
    },
    // 删除一条新的筛选条件
    deleteSearchItem (searchItems, index) {
      searchItems.splice(index, 1)
    },
    // 提交检索
    submitSearch () {
      let highSearch = {
        searchList: this.searchList,
        postTime: this.postTime,
        updateTime: this.updateTime
      }
      this.$store.commit('SET_HIGH_SEARCH', highSearch)
      this.$emit('high-search', highSearch)
    },
    // 清空搜索条件
    clearSearch () {
      this.$store.commit('SET_HIGH_SEARCH', null)
      this.searchList = [
        {
          id: 'aaa',
          searchItems: [
            {
              word: '',
              type: '分类'
              // accuracy: '精确'
            }
          ],
          rule: '&'
        }
      ]
      this.postTime = null
      this.updateTime = ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.search-group
  text-align center
  margin-bottom 20px

.add-group
  width fit-content
  cursor pointer
  margin 0px auto
  margin-bottom 20px
  &:hover
    color #E60012

.search-item
  margin-bottom 20px

  .search-option
    flex 1
    margin 0px 10px

  .rule-wrapper, .button-wrapper
    flex none
    width 80px
    text-align center

  .el-icon-delete
    cursor pointer
    &:hover
      color #E60012

  .button-wrapper
    font-size 18px
    color #E60012
    i
      cursor pointer
      &:hover
        opacity 0.8

.time-options
  margin-left 20px

  .options-item
    margin-right 20px

  .title
    display inline-block
    width 80px

.bottom-button
  position relative
  margin-top 50px
  text-align center

  .clear-text
    position absolute
    cursor pointer
    top 50%
    left 34%
    font-size 16px
    transform translate(-34%, -50%)
    &:hover
      opacity 0.8

  .submit-button
    cursor pointer
    width 120px
    border-radius 6px
    outline none
    border none
    color #fff
    background #E60012
    font-size 18px
    padding 12px 0px
    &:hover
      opacity 0.8
</style>

<style lang="stylus">
.type-select
  .el-input-group__append,
  .el-input-group__prepend
    width 100px
    background #fff
    color #E60012
    border 1px solid #E60012
    .el-select .el-input__inner
      border-width 0px
  .el-input-group__append
    width 80px
  .el-select .el-input .el-select__caret
    color #E60012

  .el-select .el-input__inner
    color #E60012
    border 1px solid #E60012

.search-option
  .el-input__inner:first-child
    border-radius 4px 0px 0px 4px
  .el-input__inner:last-child
    border-radius 0px 4px 4px 0px
    border-width 1px 1px 1px 0px
</style>
